export const getUndoablePendingSupplyActions = (pendingSupply) => {
  return pendingSupply.filter(action => {
    return !action.isNotUndoable
  })
}